import { report, reportBuilder, reportBuilderPurchaseAbroadPackage } from '../utilities/tagManager/tagManager';

const tagManagerMiddleware = (store) => (next) => (action) => {
    try {
        const state = store.getState();

        switch (action.type) {
            case "saleBlock/reportTagManager": {
                switch(action.payload) {
                    case 'saleTransaction': {
                        const transactionInfo = {
                            transactionId: state.saleBlock.transactionId,
                            saleType: state.saleBlock.saleType,
                            totalPrice: state.saleBlock.totalPrice,
                            totalPriceOneTime:  state.saleBlock.totalPriceOneTime,
                            offerInfo: state.saleBlock.epiServer.offerInfo,
                            selectedProducts: state.saleBlock.productsInfo.selectedProducts,
                            vasList: state.saleBlock.vasList,
                        }

                        const reportItem = reportBuilder.saleTransaction(transactionInfo);
                        report(reportItem);
                    }
                    break;
                }
                break;
            }
            case "cellcomAbroad/eCommerceReportBuyRegularPackage": {

                const {cellcomAbroad} = state;
                const {selectedAbroadPackage} = cellcomAbroad;
                
                const transactionInfo = {
                    transactionId: selectedAbroadPackage?.socCode,
                    revenue: selectedAbroadPackage?.price,
                    name: selectedAbroadPackage?.titleEpi,
                    id: selectedAbroadPackage?.socCode,
                    price: selectedAbroadPackage?.price,
                }
                const reportItem = reportBuilderPurchaseAbroadPackage.saleTransaction(transactionInfo);
                report(reportItem);
                break;
            }

            case "cellcomAbroad/eCommerceReportFamilyPackage": {
                const {cellcomAbroad} = state;
                const {selectedAbroadPackage} = cellcomAbroad;
                
                const transactionInfo = {
                    transactionId: selectedAbroadPackage?.socCode,
                    revenue: selectedAbroadPackage?.price,
                    name: selectedAbroadPackage?.titleEpi,
                    id: selectedAbroadPackage?.socCode,
                    price: selectedAbroadPackage?.price,
                }
                const reportItem = reportBuilderPurchaseAbroadPackage.saleTransaction(transactionInfo);
                report(reportItem);
                break;
            }
        }
    } catch (error) {
    }

    return next(action);

};

export default tagManagerMiddleware;
